var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49944 3L4.28516 6.21429V17.7857H8.1423V21L11.3566 17.7857H13.928L19.7137 12V3H7.49944ZM18.428 11.3571L15.8566 13.9286H13.2852L11.0352 16.1786V13.9286H8.1423V4.28571H18.428V11.3571Z",
    fill: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4994 6.53569H15.2137V10.3928H16.4994V6.53569Z",
    fill: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9637 6.53569H11.678V10.3928H12.9637V6.53569Z",
    fill: "#F7FCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.bc682a1ba542c8869c1d825526389040.svg";
export { ForwardRef as ReactComponent };